import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import fileDownload from 'js-file-download';
import { EXPORT_BOS_API_REQUEST_URL } from '../../../../common/apiConfig';
import {
  MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_BEGIN,
  MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_SUCCESS,
  MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_FAILURE,
  MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_DISMISS_ERROR,
} from './constants';

export function exportHistorySearch(args = {}) {
  return (dispatch, getState) => {
    dispatch({ type: MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_BEGIN });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;

      const doRequest = axios({
        url: `${EXPORT_BOS_API_REQUEST_URL}/manageOutsHistorySearch/export`,
        method: 'post',
        data: args,
        responseType: 'blob',
        headers: { Authorization: token },
      });

      doRequest.then(
        (res) => {
          dispatch({ type: MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_SUCCESS, data: res.data });
          // download file (filename optional if backend sets header)
          fileDownload(res.data, 'ManageOutsAudit_Orders.xlsx');
          resolve(res);
        },
        (err) => {
          const message = err && err.response ? (err.response.data && err.response.data.message) || err.response.statusText : 'Export failed';
          dispatch({ type: MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_FAILURE, data: { error: message } });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportHistorySearchError() {
  return { type: MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_DISMISS_ERROR };
}

export function useExportHistorySearch() {
  const dispatch = useDispatch();
  const { exportHistorySearchPending, exportHistorySearchError } = useSelector(
    state => ({
      exportHistorySearchPending: state.manageOutsAuditTrail.exportHistorySearchPending,
      exportHistorySearchError: state.manageOutsAuditTrail.exportHistorySearchError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => dispatch(exportHistorySearch(...args)), [dispatch]);
  const boundDismiss = useCallback(() => dispatch(dismissExportHistorySearchError()), [dispatch]);

  return {
    exportHistorySearch: boundAction,
    exportHistorySearchPending,
    exportHistorySearchError,
    dismissExportHistorySearchError: boundDismiss,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_BEGIN:
      return { ...state, exportHistorySearchPending: true, exportHistorySearchError: null };
    case MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_SUCCESS:
      return { ...state, exportHistorySearchPending: false, exportHistorySearchError: null };
    case MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_FAILURE:
      return { ...state, exportHistorySearchPending: false, exportHistorySearchError: action.data.error };
    case MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_DISMISS_ERROR:
      return { ...state, exportHistorySearchError: null };
    default:
      return state;
  }
}

